"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTitle = void 0;
const react_1 = require("react");
/**
 * @description This hook updates the document title, recommended to have an instance on app page
 */
const useTitle = (title = "") => {
    (0, react_1.useEffect)(() => {
        const oldTitle = document.title;
        document.title = title;
        return () => {
            document.title = oldTitle;
        };
    }, [title]);
};
exports.useTitle = useTitle;
//# sourceMappingURL=useTitle.js.map